(function ($) {
	var bodyclasses = $('body').attr('class');
	var match = false;
	var compareclasses = ['page-template-places-page', 'page-template-all-places-page', 'page-template-account-page', 'page-template-events-page', 'page-template-password-reset', 'single'];

	for (var i = 0; i < compareclasses.length; i++) {
		if (bodyclasses.indexOf(compareclasses[i]) >= 0) {
			match = true;
			break;
		}
	}

	$(window).scroll(function () {
		$('header').toggleClass('is-sticky', $(document).scrollTop() > 210)
        $('.filter').toggleClass('is-sticky', $(document).scrollTop() > 210)

        $(".no-auth-wrapper").each( function() {
            if ($(document).scrollTop() > 210) {
            	if(document.documentElement.lang == 'fr-FR') {
                    $('.logo-link img').attr('src','/wp-content/themes/historicplacesday/assets/images/HPD-Logo-FR.svg');
            	}
            	else {
            		$('.logo-link img').attr('src','/wp-content/themes/historicplacesday/assets/images/HPD-Logo.svg');
            	}
            }
            else if ($(document).scrollTop() < 210) {
                if (match && document.documentElement.lang == 'fr-FR') {
                    $('.logo-link img').attr('src', '/wp-content/themes/historicplacesday/assets/images/HPD-Logo-FR.svg');
                }
                else if (match) {
                    $('.logo-link img').attr('src', '/wp-content/themes/historicplacesday/assets/images/HPD-Logo.svg');
                }
            	else if(document.documentElement.lang == 'fr-FR') {
                	$('.logo-link img').attr('src','/wp-content/themes/historicplacesday/assets/images/HPD-Logo-FR-White.svg');
                }
                else {
                    $('.logo-link img').attr('src','/wp-content/themes/historicplacesday/assets/images/logo-White.svg');
                }
            }
        })
    });

    $(window).trigger('scroll');
})(jQuery);

